<!-- Notifications Dropdown -->
<div
    class="relative"
    (clickOutside)="closeDropdown()"
>
    <!-- Bell Icon with Badge -->
    <button
        type="button"
        class="relative p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        (click)="toggleDropdown()"
    >
        <icon-bell-bing />

        <!-- Badge -->
        @if (showBadge()) {
            <span class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full p-0.5 px-1 flex items-center justify-center">
                {{ badgeText() }}
            </span>
        } @else {
            <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
                <span
                    class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"
                ></span>
                <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"> </span>
            </span>
        }
    </button>

    <!-- Dropdown Menu -->
    @if (isDropdownOpen()) {
        <div class="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
            <!-- Header -->
            <div class="p-4 border-b border-gray-200 dark:border-gray-700">
                <div class="flex items-center justify-between">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white"> Notificações </h3>
                    @if (unreadCount() > 0) {
                        <button
                            type="button"
                            class="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                            (click)="markAllAsRead(); $event.stopPropagation()"
                        >
                            Marcar todas como lidas
                        </button>
                    }
                </div>
            </div>

            <!-- Tabs Navigation -->
            <div class="border-b border-gray-200 dark:border-gray-700">
                <nav
                    class="flex space-x-8 px-4"
                    aria-label="Tabs"
                >
                    <!-- Tab Pendentes -->
                    <button
                        type="button"
                        [class]="
                            activeTab() === 'unread'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                        "
                        class="whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center"
                        (click)="setActiveTab('unread')"
                    >
                        <svg
                            class="w-4 h-4 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                        </svg>
                        Pendentes
                        @if (unreadNotifications().length > 0) {
                            <span class="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                                {{ unreadNotifications().length }}
                            </span>
                        }
                    </button>

                    <!-- Tab Lidas -->
                    <button
                        type="button"
                        [class]="
                            activeTab() === 'read'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                        "
                        class="whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center"
                        (click)="setActiveTab('read')"
                    >
                        <svg
                            class="w-4 h-4 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                        Lidas
                        @if (readNotifications().length > 0) {
                            <span class="ml-2 bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full dark:bg-gray-700 dark:text-gray-300">
                                {{ readNotifications().length }}
                            </span>
                        }
                    </button>
                </nav>
            </div>
            <!-- Filtros e Busca -->
            <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                <div class="flex items-center justify-between gap-2">
                    <!-- Botão de busca -->
                    <button
                        type="button"
                        [class]="
                            showSearch()
                                ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-300'
                                : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-gray-300'
                        "
                        class="flex items-center gap-1.5 px-2.5 py-1.5 border rounded-md transition-all duration-200 flex-1 justify-center"
                        (click)="toggleSearch(); $event.stopPropagation()"
                    >
                        <svg
                            class="h-3.5 w-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            ></path>
                        </svg>
                        <span class="text-xs font-medium">Pesquisar</span>
                    </button>

                    <!-- Botão de filtros -->
                    <button
                        type="button"
                        [class]="
                            showEntityFilters()
                                ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-300'
                                : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-gray-300'
                        "
                        class="flex items-center gap-1.5 px-2.5 py-1.5 border rounded-md transition-all duration-200 flex-1 justify-center"
                        (click)="toggleEntityFilters(); $event.stopPropagation()"
                    >
                        <svg
                            class="h-3.5 w-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.707A1 1 0 013 7V4z"
                            ></path>
                        </svg>
                        <span class="text-xs font-medium">Filtrar</span>
                    </button>
                </div>
            </div>

            <!-- Search Filter (condicional) -->
            @if (showSearch()) {
                <div class="border-b border-gray-200 dark:border-gray-700">
                    <div class="px-4 py-3">
                        <div class="relative">
                            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg
                                    class="h-4 w-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                type="text"
                                [value]="searchQuery()"
                                (input)="onSearchInput($event)"
                                placeholder="Buscar por nome, condomínio, descrição..."
                                class="block w-full pl-10 pr-10 py-1 border border-gray-300 dark:border-gray-600 rounded-lg text-sm placeholder-gray-500 dark:placeholder-gray-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                            />
                            @if (searchQuery()) {
                                <button
                                    type="button"
                                    (click)="clearSearch(); $event.stopPropagation()"
                                    class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                                >
                                    <svg
                                        class="h-4 w-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        ></path>
                                    </svg>
                                </button>
                            }
                        </div>

                        <!-- Indicador de resultados da busca -->
                        @if (searchResultsCount() !== null) {
                            <div class="mt-2 px-1">
                                <span class="text-xs text-gray-600 dark:text-gray-400">
                                    @if (searchResultsCount() === 0) {
                                        Nenhum resultado encontrado
                                    } @else if (searchResultsCount() === 1) {
                                        1 resultado encontrado
                                    } @else {
                                        {{ searchResultsCount() }} resultados encontrados
                                    }
                                </span>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Entity Type Filter Tabs (condicional) -->
            @if (showEntityFilters() && availableEntityTypes().length > 0) {
                <div class="border-b border-gray-200 dark:border-gray-700">
                    <div class="px-4 py-2">
                        <div class="flex items-center justify-between mb-2">
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Filtrar por tipo:</span>
                            @if (activeEntityType()) {
                                <button
                                    type="button"
                                    class="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400"
                                    (click)="setActiveEntityType(null); $event.stopPropagation()"
                                >
                                    Limpar filtro
                                </button>
                            }
                        </div>

                        <!-- Entity Type Chips -->
                        <div class="flex flex-wrap gap-2">
                            <!-- All Types -->
                            <button
                                type="button"
                                [class]="
                                    !activeEntityType()
                                        ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
                                "
                                class="px-3 py-1 rounded-full text-xs font-medium transition-colors flex items-center"
                                (click)="setActiveEntityType(null)"
                            >
                                <i class="fas fa-list mr-1"></i>
                                Todas

                                <!-- Contador total -->
                                @if (getTotalCountForActiveTab() > 0) {
                                    <span
                                        class="ml-1 px-1.5 py-0.5 rounded-full text-xs font-semibold"
                                        [class]="
                                            !activeEntityType()
                                                ? 'bg-blue-200 text-blue-900 dark:bg-blue-800 dark:text-blue-200'
                                                : 'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-200'
                                        "
                                    >
                                        {{ getTotalCountForActiveTab() }}
                                    </span>
                                }
                            </button>

                            <!-- Entity Type Buttons -->
                            @for (entityType of availableEntityTypes(); track entityType) {
                                <button
                                    type="button"
                                    [class]="
                                        activeEntityType() === entityType
                                            ? getActiveButtonClass(entityType)
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
                                    "
                                    class="px-3 py-1 rounded-full text-xs font-medium transition-colors flex items-center"
                                    (click)="setActiveEntityType(entityType)"
                                >
                                    <i
                                        [class]="getEntityTypeIcon(entityType)"
                                        class="mr-1"
                                    ></i>
                                    {{ getEntityTypeName(entityType) }}

                                    <!-- Contador -->
                                    @if (getEntityTypeCountForActiveTab(entityType) > 0) {
                                        <span
                                            class="ml-1 px-1.5 py-0.5 rounded-full text-xs font-semibold"
                                            [class]="
                                                activeEntityType() === entityType
                                                    ? getActiveBadgeClass(entityType)
                                                    : 'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-200'
                                            "
                                        >
                                            {{ getEntityTypeCountForActiveTab(entityType) }}
                                        </span>
                                    }
                                </button>
                            }
                        </div>
                    </div>
                </div>
            }

            <!-- Tab Content -->
            <div class="max-h-96 overflow-y-auto">
                @if (isLoading()) {
                    <!-- Loading State -->
                    <div class="p-4 text-center">
                        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
                        <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">Carregando notificações...</p>
                    </div>
                } @else {
                    <!-- Tab Pendentes -->
                    @if (activeTab() === 'unread') {
                        @if (filteredNotifications().length === 0) {
                            <!-- Empty State for Unread -->
                            <div class="p-4 text-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-12 w-12 text-gray-400 mx-auto mb-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <p class="text-sm text-gray-500 dark:text-gray-400">
                                    @if (searchQuery()) {
                                        Nenhuma notificação encontrada para "{{ searchQuery() }}"
                                        @if (activeEntityType()) {
                                            em {{ getEntityTypeName(activeEntityType()!) }}
                                        }
                                    } @else if (activeEntityType()) {
                                        Nenhuma notificação pendente de {{ getEntityTypeName(activeEntityType()!) }}
                                    } @else {
                                        Nenhuma notificação pendente
                                    }
                                </p>
                                @if (searchQuery()) {
                                    <button
                                        type="button"
                                        (click)="clearSearch(); $event.stopPropagation()"
                                        class="mt-2 text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400"
                                    >
                                        Limpar busca
                                    </button>
                                }
                            </div>
                        } @else {
                            @for (notification of filteredNotifications(); track notification.id) {
                                <div
                                    [ngClass]="getNotificationClass(notification)"
                                    (click)="markAsRead(notification)"
                                    class="cursor-pointer"
                                    [style.border-left]="getNotificationBorderColor(notification)"
                                >
                                    <!-- Icon -->
                                    <div class="flex-shrink-0 mr-3 relative">
                                        <div class="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                                            <i
                                                [class]="getNotificationIcon(notification)"
                                                class="text-blue-600 dark:text-blue-400 text-sm"
                                            ></i>
                                        </div>
                                        <!-- Indicador de não lida -->
                                        <div class="absolute -top-1 -right-1 w-3 h-3 bg-orange-500 rounded-full"></div>
                                    </div>

                                    <!-- Content -->
                                    <div class="flex-1 min-w-0">
                                        <p class="text-sm font-medium text-gray-900 dark:text-white">
                                            {{ notification.title }}
                                        </p>
                                        <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                            {{ notification.message }}
                                        </p>
                                        <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
                                            {{ formatTime(notification.createdAt) }}
                                        </p>
                                    </div>

                                    <!-- Actions -->
                                    <div class="flex-shrink-0 ml-2">
                                        <button
                                            type="button"
                                            class="text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                                            (click)="removeNotification(notification); $event.stopPropagation()"
                                            title="Remover notificação"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="h-4 w-4"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                />
                                            </svg>
                                        </button>
                                    </div>

                                    <!-- Unread Indicator -->
                                    <div class="absolute left-0 top-0 bottom-0 w-1 bg-blue-300 rounded-r"></div>
                                </div>
                            }
                        }
                    }

                    <!-- Tab Lidas -->
                    @if (activeTab() === 'read') {
                        @if (filteredNotifications().length === 0) {
                            <!-- Empty State for Read -->
                            <div class="p-4 text-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-12 w-12 text-gray-400 mx-auto mb-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <p class="text-sm text-gray-500 dark:text-gray-400">
                                    @if (searchQuery()) {
                                        Nenhuma notificação encontrada para "{{ searchQuery() }}"
                                        @if (activeEntityType()) {
                                            em {{ getEntityTypeName(activeEntityType()!) }}
                                        }
                                    } @else if (activeEntityType()) {
                                        Nenhuma notificação lida de {{ getEntityTypeName(activeEntityType()!) }}
                                    } @else {
                                        Nenhuma notificação lida
                                    }
                                </p>
                                @if (searchQuery()) {
                                    <button
                                        type="button"
                                        (click)="clearSearch(); $event.stopPropagation()"
                                        class="mt-2 text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400"
                                    >
                                        Limpar busca
                                    </button>
                                }
                            </div>
                        } @else {
                            @for (notification of filteredNotifications(); track notification.id) {
                                <div
                                    [ngClass]="getNotificationClass(notification)"
                                    (click)="onReadNotificationClick(notification)"
                                    class="cursor-pointer"
                                    [style.border-left]="getNotificationBorderColor(notification)"
                                >
                                    <!-- Icon -->
                                    <div class="flex-shrink-0 mr-3 relative">
                                        <div class="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
                                            <i
                                                [class]="getNotificationIcon(notification)"
                                                class="text-gray-500 dark:text-gray-400 text-sm"
                                            ></i>
                                        </div>
                                        <!-- Indicador de lida -->
                                        <div class="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full flex items-center justify-center">
                                            <svg
                                                class="w-2 h-2 text-white"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                    clip-rule="evenodd"
                                                ></path>
                                            </svg>
                                        </div>
                                    </div>

                                    <!-- Content -->
                                    <div class="flex-1 min-w-0">
                                        <p class="text-sm font-medium text-gray-600 dark:text-gray-400">
                                            {{ notification.title }}
                                        </p>
                                        <p class="text-sm text-gray-400 dark:text-gray-500 mt-1">
                                            {{ notification.message }}
                                        </p>
                                        <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
                                            {{ formatTime(notification.createdAt) }}
                                        </p>
                                    </div>

                                    <!-- Actions -->
                                    <div class="flex-shrink-0 ml-2">
                                        <button
                                            type="button"
                                            class="text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                                            (click)="removeNotification(notification); $event.stopPropagation()"
                                            title="Remover notificação"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="h-4 w-4"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                />
                                            </svg>
                                        </button>
                                    </div>

                                    <!-- Read Indicator -->
                                    <div class="absolute left-0 top-0 bottom-0 w-1 bg-gray-300 dark:bg-gray-600 rounded-r"></div>
                                </div>
                            }
                        }
                    }
                }
            </div>

            <!-- Footer -->
            @if (notifications().length > 0) {
                <div class="p-3 border-t border-gray-200 dark:border-gray-700">
                    <button
                        type="button"
                        class="w-full text-center text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        (click)="closeDropdown()"
                    >
                        <!-- Ver todas as notificações -->
                        Fechar notificações
                    </button>
                </div>
            }
        </div>
    }
</div>

<!-- Popup de Alerta para Ocorrências e Pânico (fila) -->
<app-alert-popup
    [queue]="alertPopupQueue()"
    (close)="onAlertClose($event)"
    (next)="onAlertNext($event)"
    (previous)="onAlertPrevious()"
    (open)="onAlertOpen($event)"
    (closeAll)="onAlertCloseAll()"
>
</app-alert-popup>
